import wyklady2024 from './static/wyklady2024.json'

export interface Item {
    id: string;
    type: string;
    parentId?: string;
}

export interface Episode extends Item {
    title: string;
    subtitle?: string;
    author: string;
    description?: string;
}

export interface Series extends Item {
    title: string;
    subtitle?: string;
    author?: string;
    description?: string;
    episodes: Array<Episode>;
}

export interface YouToube extends Item {
    url: string
}

export interface Audio extends Item {
    url: string
}

export interface Book extends Item {
    title: string;
    author?: string;
}

export function encodeUrl(url: string) {
    if (url.startsWith('http')) {
        return url;
    }
    return encodeURI(url);
}


export function getItems(parent: Item) {
    return wyklady2024.items.filter((item) => item.parentId === parent.id);
}

export function getItem(id: string) {
    return wyklady2024.items.filter((item) => item.id === id)[0];
}

export function hasItems(parent: Item) {
    return getItems(parent).length > 0;
}

